/* c-floating-buttons
 * - Type 1 (ラベル): リンク優先、JS 介入なし（CSS :hover で開閉）
 *   SP（タッチ）では :hover が二段階タップになるので、ボタン要素時のみクリックで is-active トグル
 * - Type 2 (ポップアップ): クリックで is-active トグル / 外側クリック・ESC で閉じる
 * - 複数 c-floating-buttons セクション同居 OK（section.id スコープ）
 * - Theme editor の section:load イベントで再初期化
 */
(function () {
  'use strict';

  var INITIALIZED_ATTR = 'data-c-fb-initialized';

  function closeAllPopups(root) {
    var openItems = root.querySelectorAll('.c-floating-buttons__item.is-active');
    for (var i = 0; i < openItems.length; i++) {
      openItems[i].classList.remove('is-active');
      var btn = openItems[i].querySelector('.c-floating-buttons__btn[aria-expanded]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      var popup = openItems[i].querySelector('.c-floating-buttons__popup');
      if (popup) popup.setAttribute('aria-hidden', 'true');
    }
  }

  function bindRoot(root) {
    if (!root || root.getAttribute(INITIALIZED_ATTR) === 'true') return;
    root.setAttribute(INITIALIZED_ATTR, 'true');

    var items = root.querySelectorAll('.c-floating-buttons__item');

    items.forEach(function (item) {
      var type = item.getAttribute('data-type');
      var btn = item.querySelector('.c-floating-buttons__btn');
      if (!btn) return;

      // Type 1: ボタン要素（リンクなし）の場合のみ、SP タップでラベル開閉
      if (type === '1' && btn.tagName === 'BUTTON') {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var isOpen = item.classList.toggle('is-active');
          btn.setAttribute('aria-pressed', isOpen ? 'true' : 'false');
        });
      }

      // Type 2: ポップアップ開閉
      if (type === '2') {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var wasOpen = item.classList.contains('is-active');
          // 同セクション内の他のポップアップを閉じる
          closeAllPopups(root);
          if (!wasOpen) {
            item.classList.add('is-active');
            btn.setAttribute('aria-expanded', 'true');
            var popup = item.querySelector('.c-floating-buttons__popup');
            if (popup) popup.setAttribute('aria-hidden', 'false');
          }
        });
      }
    });

    // 外側クリックで閉じる
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) {
        closeAllPopups(root);
      }
    });

    // ESC キーで閉じる
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        closeAllPopups(root);
      }
    });
  }

  function init() {
    document.querySelectorAll('.c-floating-buttons[data-section-id]').forEach(bindRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: section re-render 対応
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.c-floating-buttons[data-section-id]');
    if (root) bindRoot(root);
  });
})();
